import ResetPassword from "../Screens/Auth/ResetPassword/resetPassword";
import UpdatePassword from "../Screens/Auth/ResetPassword/updatePassword";
import Dashboard from "../Screens/DashboardView/Dashboard/Dashboard";
import {
  Route,
  BrowserRouter,
  Routes,
  Navigate,
  useLocation,
} from "react-router-dom";
import HomePage from "../Screens/HomePage/HomePage";
import SignUp from "../Screens/Auth/SignUpAuth/SignUp";
import ProtectedRoute from "./ProtectedRoute";
import GlobalView from "../Screens/GlobalView/GlobalView";
import Login from "../Screens/Auth/LoginAuth/Login";
import Error404 from "../ErrorPages/Error404";
import Error401 from "../ErrorPages/Error401";
import Error400 from "../ErrorPages/Error400";
import NoUser from "../ErrorPages/NoUser";
import AuthRoute from "./AuthRoute";
import GoogleCallback from "../components/GoogleCallback/GoogleCallback";
import Privacy from "../Utils/Privacy";
import SubscribeTest from "../Utils/SubscribeTest";
import PaymentCanceled from "../Utils/PaymentCanceled";
import FollowerView from "../Screens/FollowerView/FollowerView";
import LoadingDummyPage from "../Screens/LoadingDummyPage/LoadingDummyPage";
import EmailLogin from "../Screens/Auth/LoginProviders/EmailLogin";
import DashboardRedirect from "../Screens/DashboardView/Dashboard/DashboardRedirect";
import HowItWorks from "../Utils/HowItWorks";
import { useEffect } from "react";
import OnboardingPage from "../Screens/Auth/OnboardingFlow/OnboardingPage";
import PaymentStatus from "../Screens/Payment/PaymentStatus";
import TeamPaymentSuccess from "../Screens/Payment/TeamPaymentSuccess";
import { SidebarProvider } from "../context/SidebarContext";
import { SidebarStateProvider } from "../context/SidebarStateContext";
import EmbeddedView from "../Screens/EmbeddedView/EmbeddedView";
import AcceptInvitePage from "../Screens/Auth/AcceptInvite/AcceptInvitePage";
import AddMember from "../Screens/DashboardView/Account/AccountSection/AddMember";
import AdminLogin from "../Screens/Auth/LoginProviders/AdminLogin";
import Tutorials from "../Screens/DashboardView/Tutorials/Tutorials";
import EmbedViewHtml from "../Screens/EmbeddedView/EmbedViewHtml";
import { supabase } from "../config/supabaseClient";

function getCreatorFromHost(): string | undefined {
  const hostname = window.location.hostname;
  const map: Record<string, string> = {
    "searchable.me": "sbcheck9",
    "browze.in": "eleganceny",
    "browze.co": "orenmeetsworld"
  };

  return map[hostname];
}

// function getParamId(): string | undefined {
//   const slug = getCreatorFromHost(); // e.g. 'sbcheck9'
//   const path = window.location.pathname; // e.g. '/sbcheck9/reewed'
  
//   // Ensure path starts with slug
//   if (slug && path.startsWith(`/${slug}/`)) {
//     const parts = path.split('/'); // ['', 'sbcheck9', 'reewed']
//     return parts[2]; // reewed
//   }

//   return undefined;
// }
function getParamId(): string | undefined {
  const slug = getCreatorFromHost(); // e.g. 'sbcheck9'
  const path = window.location.pathname; // e.g. '/reewed'

  if (slug && path) {
    const parts = path.split('/'); // ['', 'reewed']
    return parts[1] || undefined;  // 'reewed'
  }

  return undefined;
}


const Routing = () => {
  const actualLocation = useLocation();
  const creatorSlug = getCreatorFromHost();
  const paramId = getParamId();

  // Create a modified location that includes both creator slug and param ID if they exist
  const spoofedLocation = creatorSlug
    ? {
        ...actualLocation,
        pathname: paramId ? `/${creatorSlug}/${paramId}` : `/${creatorSlug}`,
      }
    : actualLocation;

  function PrivateBetaRedirect() {
    useEffect(() => {
      window.location.href =
        "https://calendly.com/searchbubble/private-beta-onboarding?month=2024-09";
    }, []);

    return null;
  }

  return (
    <SidebarStateProvider>
      <SidebarProvider>
        <Routes location={spoofedLocation}>
          <Route path="/" element={<AuthRoute Component={HomePage} />} />
          <Route path="/login" element={<AuthRoute Component={Login} />} />
          <Route
            path="/onboarding"
            element={<AuthRoute Component={OnboardingPage} />}
          />
          <Route path="/tutorials" element={<Tutorials />} />
          <Route path="/signup" element={<AuthRoute Component={SignUp} />} />
          <Route path="/googleCallback" element={<GoogleCallback />} />
          <Route path="/auth/update-password" element={<UpdatePassword />} />
          <Route path="/login-email" element={<EmailLogin />} />
          <Route path="/login-admin" element={<AdminLogin />} />
          <Route path="/subscribe" element={<SubscribeTest />} />
          <Route path="/payment-status" element={<PaymentStatus />} />
          <Route path="/payment-canceled" element={<PaymentCanceled />} />
          <Route path="/add-team-payment-success" element={<TeamPaymentSuccess />} />
          <Route path="/add-member" element={<AddMember />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/accept-invite" element={<AcceptInvitePage />} />
          <Route path="/googleCallback" element={<GoogleCallback />} />
          <Route path="/auth/update-password" element={<UpdatePassword />} />
          <Route path="/login-email" element={<EmailLogin />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route
            path="/loading/:username"
            element={<ProtectedRoute Component={LoadingDummyPage} />}
          />

          <Route
            path="/dashboard/:username"
            element={<ProtectedRoute Component={Dashboard} />}
          />

          <Route
            path="/dashboard/productbank/:username"
            element={<ProtectedRoute Component={Dashboard} />}
          />
          <Route path="/dashboard/" element={<DashboardRedirect />} />
          <Route
            path="/preview/:username"
            element={<ProtectedRoute Component={FollowerView} />}
          />
          <Route path="/:username">
            <Route index element={<FollowerView />} />
            <Route path="contact-me" element={<FollowerView />} />
            <Route path=":id" element={<FollowerView />} />
          </Route>

          <Route path="/embed/:username" element={<EmbeddedView />} />
          <Route path="/embeddemo/:username" element={<EmbedViewHtml />} />

          <Route path="/global" element={<GlobalView />} />
          <Route path="/private-beta" element={<PrivateBetaRedirect />} />
          <Route path="/global?term=:queryTerm&from=:searchFrom" element={<GlobalView />} />
          <Route path="/no-user-found" element={<NoUser />} />
          <Route path="/404" element={<Error404 />} />
          <Route path="/401" element={<Error401 />} />
          <Route path="/*" element={<Error400 />} />
          <Route path="/privacy" element={<Privacy />} />
        </Routes>
      </SidebarProvider>
    </SidebarStateProvider>
  );
};

export default Routing;
